import "./HousemateManager.ts";
import api from "./API";
import {Housemate} from "../Types/Housemate";

export async function getHousemates(): Promise<Housemate[]> {
    try {
        const response = await api.get("/api/unihouse/get/housemates");
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}